import { render } from "./SlotDisplay.vue?vue&type=template&id=318d9c38&scoped=true"
import script from "./SlotDisplay.vue?vue&type=script&lang=js"
export * from "./SlotDisplay.vue?vue&type=script&lang=js"

import "./SlotDisplay.vue?vue&type=style&index=0&id=318d9c38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318d9c38"]])

export default __exports__